module.exports = __webpack_public_path__ + "img/1472392291.b62ffa92.jpg";